import { sessaoFetchLoading } from '@/service/fetch'
import { serialize } from '@/service/util'

export async function relatorioMensal (param = {}) {
  return sessaoFetchLoading(`base`, `/meta/mensal?${serialize(param)}`)
}
export async function producaoDiaria (param = {}) {
  return sessaoFetchLoading(`base`, `/meta/diaria?${serialize(param)}`)
}
export async function producaoMensal (param = {}) {
  return sessaoFetchLoading(`base`, `/meta/producao/mensal?${serialize(param)}`)
}
export async function rankingUsuario (param = {}) {
  return sessaoFetchLoading(`base`, `/meta/ranking/usuario?${serialize(param)}`)
}
export async function estatisticaTlmk (param = {}) {
  return sessaoFetchLoading(`base`, `/estatistica/telemarketing?${serialize(param)}`)
}
export async function listPeriodos (param = {}) {
  return sessaoFetchLoading(`base`, `/metas?${serialize(param)}`)
}



// WEBPACK FOOTER //
// ./src/api/meta.js